import React, { useState } from 'react';
import './CallToAction.css';
import EmailPopup from './EmailPopup';

const CallToAction = () => {
  const [showPopup, setShowPopup] = useState(false);

  const handleGetStarted = () => {
    setShowPopup(true);
  };

  return (
    <section className="call-to-action">
      <div className="cta-content">
        <h2 className="goldman-bold">Ready to Start Your Journey?</h2>
        <div className="cta-buttons">
          <button className="cta-primary goldman-bold" onClick={handleGetStarted}>Get started</button>
        </div>
      </div>
      <EmailPopup isOpen={showPopup} onClose={() => setShowPopup(false)} />
    </section>
  );
};

export default CallToAction;